"use client";

import { Minus } from "@/components/icons/minus";
import { cn } from "@/libs/base/utils/layout";
import { JSX, JSXElementConstructor, useEffect, useState } from "react";

interface ComponentProps {
  as?: keyof JSX.IntrinsicElements | JSXElementConstructor<any>;
  className?: string;
  iconClassName?: string;
  showMode: "minus" | "plus";
}

export default function PlusMinusTransition(props: ComponentProps) {
  const RootElement = props.as || "div";

  const [hideMinus, setHideMinus] = useState(false);

  useEffect(() => {
    setHideMinus(false);
  }, [props.showMode]);

  return (
    <RootElement className={cn("relative h-4 w-4", props.className)}>
      <Minus
        className={cn(
          "absolute right-0 h-4 w-4",
          "transition-transform duration-500 ease-in-out",
          props.showMode == "minus" && "rotate-0",
          props.showMode == "plus" && "rotate-90",
          hideMinus && "opacity-0",
          !hideMinus && "opacity-100",
          props.iconClassName,
        )}
        onTransitionEnd={() => props.showMode == "minus" && setHideMinus(true)}
      />
      <Minus className={cn("absolute right-0 h-4 w-4", props.iconClassName)} />
    </RootElement>
  );
}
